export const hasExpired = (expiresAt: unknown): boolean => {
  if (typeof expiresAt !== 'string') return true

  const expiry = new Date(expiresAt).getTime()
  return !Number.isFinite(expiry) || expiry <= Date.now()
}
